import { createReminder, deleteWealthManagerReminder, updateWealthManagerReminder } from './effects'
import { EDIT_FORM } from './Views/Form/formModes'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_FORM = 'GO_TO_FORM'
export const NAVIGATE_TO_INDEX = 'NAVIGATE_TO_INDEX'
export const SET_REMINDERS = 'SET_REMINDERS'
export const SET_LOADING = 'SET_LOADING'
export const GO_TO_DESTROY = 'GO_TO_DESTROY'
export const GO_TO_ERROR = 'GO_TO_ERROR'
export const SET_DESTROYING = 'SET_DESTROYING'
export const REMINDER_CREATED = 'REMINDER_CREATED'
export const REMINDER_DELETED = 'REMINDER_DELETED'
export const REMINDER_UPDATED = 'REMINDER_UPDATED'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),
  submitCreateReminderForm: async (values) => {
    await createReminder(state, values, dispatch)
  },
  submitUpdateReminderForm: async (values) => {
    await updateWealthManagerReminder(state, values, dispatch)
  },
  deleteReminder: async () => {
    await deleteWealthManagerReminder(state, dispatch)
  },
  cancel: () =>
    dispatch({ type: NAVIGATE_TO_INDEX }),
  goToForm: (mode, formValue) => () => {
    const reminder = mode === EDIT_FORM ? formValue : null
    dispatch({
      type: GO_TO_FORM,
      payload: { mode, reminder }
    })
  },
  goToDestroy: (reminder) => () =>
    dispatch({
      type: GO_TO_DESTROY,
      payload: { reminder }
    })
})
